import React, { useRef } from 'react';
import { Button } from '../shadcn-ui/button';
import { Camera, Video } from 'lucide-react';
import { cn } from '@/lib/utils';

const MediaPicker = ({ onAdd, disabled, className }) => {
  const imageRef = useRef();
  const videoRef = useRef();

  return (
    <div className="mt-1 overflow-hidden">
      <div className="flex flex-wrap gap-2">
        <Button
          type="button"
          variant="outline"
          className={cn("bg-white", className)}
          onClick={() => imageRef.current.click()}
          disabled={disabled}
        >
          <Camera className="mr-2 h-4 w-4" />
          Add Photo
        </Button>

        <Button
          type="button"
          variant="outline"
          className={cn("bg-white", className)}
          onClick={() => videoRef.current.click()}
          disabled={disabled}
        >
          <Video className="mr-2 h-4 w-4" />
          Add Video
        </Button>
      </div>

      <input
        ref={imageRef}
        type="file"
        accept="image/*"
        multiple
        hidden
        onChange={e => onAdd(e.target.files, 'image')}
      />

      <input
        ref={videoRef}
        type="file"
        accept="video/*"
        multiple
        hidden
        onChange={e => onAdd(e.target.files, 'video')}
      />
    </div>
  );
};

export default MediaPicker;
